import React, { useState } from 'react';
import { Row, Col, Typography } from 'antd';
import ScrollReveal from '../../components/ScrollReveal';
import industryBeverage from '../../assets/images/solutions/industry-beverage_compressed.webp';
import industryFashion from '../../assets/images/solutions/industry-fashion_compressed.webp';
import industryHardware from '../../assets/images/solutions/industry-hardware_compressed.webp';
import industryDigital from '../../assets/images/solutions/industry-digital_compressed.webp';
import industryHome from '../../assets/images/solutions/industry-home_compressed.webp';
import industryGeneral from '../../assets/images/solutions/industry-general_compressed.webp';
import serviceImg01 from '../../assets/images/solutions/cut_01_compressed.webp';
import serviceImg02 from '../../assets/images/solutions/cut_02_compressed.webp';
import serviceImg03 from '../../assets/images/solutions/cut_03_compressed.webp';
import serviceImg04 from '../../assets/images/solutions/cut_04_compressed.webp';
import {
  GiftOutlined,
  ToolOutlined,
  HomeOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  SkinOutlined,
  LaptopOutlined,
  CoffeeOutlined,
  SmileOutlined,
  BuildOutlined,
  MobileOutlined,
  ProfileOutlined,
  DatabaseOutlined,
  AccountBookOutlined,
  ClusterOutlined,
  TagsOutlined,
  CrownOutlined,
  FileDoneOutlined,
  ExperimentOutlined,
  TruckOutlined,
  AlertOutlined,
  LineChartOutlined,
  BranchesOutlined,
  PercentageOutlined,
  AuditOutlined,
  RetweetOutlined,
  EnvironmentOutlined,
  ProjectOutlined,
  ContainerOutlined,
  ScheduleOutlined,
  CalendarOutlined,
  StockOutlined,
  ThunderboltOutlined,
  SyncOutlined,
  SwapOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

// 行业 Tab 配置 — 与下方 hero 的 tab 导航对应
const industryTabs = [
  { key: 'ecom', label: '电商通用', icon: <ShoppingCartOutlined /> },
  { key: 'retail', label: '实体通用', icon: <AppstoreOutlined /> },
  { key: 'food', label: '食品酒水', icon: <CoffeeOutlined /> },
  { key: 'beauty', label: '个护化妆', icon: <SmileOutlined /> },
  { key: 'digital', label: '数码3C', icon: <LaptopOutlined /> },
  { key: 'home', label: '家居建材', icon: <BuildOutlined /> },
  { key: 'apparel', label: '服装鞋帽', icon: <SkinOutlined /> },
];

// 每个行业的方案详情 — 痛点 + 解决方案
const industryContentMap = {
  ecom: {
    title: '电商通用行业面临的经营管理痛点',
    painPoints: [
      { title: '平台多管理难', desc: '平台店铺不统一、订单管理困难' },
      { title: '订单处理效率低', desc: '审单、拆单、配合和发货复杂，峰值订单易拥堵' },
      { title: '库存精准度差', desc: '实物、占用、在途与平台库存不同步，存在超卖和积压风险' },
      { title: '财务难维护', desc: '平台回款、费用和退款分散，财务难以及时还原订单利润' },
    ],
    solutions: [
      {
        icon: <MobileOutlined />,
        title: '多平台多店铺统一经营',
        points: ['30+ 平台快速接入', '店铺分组独立运营', '跨平台商品一键铺货'],
      },
      {
        icon: <ProfileOutlined />,
        title: '订单自动化高效履约',
        points: ['智能审单与异常拦截', '自动合并拆单降低运费', '电子面单一键打印'],
      },
      {
        icon: <DatabaseOutlined />,
        title: '库存实时同步精准管控',
        points: ['多仓多店库存共享', '安全库存自动预警', '出入库全流程留痕'],
      },
      {
        icon: <AccountBookOutlined />,
        title: '财务对账与利润还原',
        points: ['平台账单自动对账', '订单级利润报表', '多维度费用分析'],
      },
    ],
  },
  retail: {
    title: '实体通用行业面临的经营管理痛点',
    painPoints: [
      { title: '门店多', desc: '商品、价格和促销规则分散，跨门店执行容易出现偏差' },
      { title: '对接慢', desc: '门店仓库协调备货发货繁杂' },
      { title: '对账难', desc: '进销存与财务独立运行，容易错账漏账' },
      { title: '核对繁', desc: '零售收款、批发欠款与退换货难以准确关联原单' },
    ],
    solutions: [
      {
        icon: <ClusterOutlined />,
        title: '多门店统一管控',
        desc: '总部统一管控门店、仓库与批发渠道，进销存与价格策略一盘棋。',
        points: ['多门店统一基础资料', '总部集中采购与调拨', '门店日报自动汇总'],
      },
      {
        icon: <TagsOutlined />,
        title: '灵活的价格策略',
        desc: '采购价、批发价、零售价、会员价、促销价多维度管理，按客户与场景自动适配。',
        points: ['多级价格体系', '客户分级报价', '促销活动灵活配置'],
      },
      {
        icon: <CrownOutlined />,
        title: '会员与营销一体化',
        desc: '会员档案、消费积分、储值卡与营销活动一站式管理，提升复购与客单价。',
        points: ['会员消费画像', '储值与积分通存通兑', '营销活动 ROI 跟踪'],
      },
      {
        icon: <FileDoneOutlined />,
        title: '业务财务一体化',
        desc: '业务单据自动生成财务凭证，账目实时更新，告别月结加班。',
        points: ['业务凭证自动生成', '多维度利润分析', '智能账表快速出具'],
      },
    ],
  },
  food: {
    title: '食品酒水行业面临的经营管理痛点',
    painPoints: [
      { title: '保质期', desc: '同一商品多批次并存，保质期管理维护难' },
      { title: '渠道多', desc: '经销、团购和零售价格不同，返利与促销核对困难' },
      { title: '销售管理', desc: '多店铺、多渠道，不同批次去向难以统一维护' },
      { title: '库存管理', desc: '销量、库存、在途与效期分散，采购容易多买或少买' },
    ],
    solutions: [
      {
        icon: <ExperimentOutlined />,
        title: '批次保质期全程追溯',
        desc: '从入库、生产到销售全流程批次管理，扫码即可追溯每件商品的来源与去向。',
        points: ['批次与保质期联动', '全程扫码留痕', '一键追溯报告'],
      },
      {
        icon: <TruckOutlined />,
        title: '多门店智能配送调拨',
        desc: '基于销量预测与库存预警，自动生成门店调拨与配送建议。',
        points: ['智能调拨建议', '配送路线优化', '门店配送时效跟踪'],
      },
      {
        icon: <ProfileOutlined />,
        title: '配方 BOM 成本核算',
        desc: '多级配方与材料耗用关系可视化，配方成本自动核算，定价有据可依。',
        points: ['多级 BOM 灵活搭建', '配方成本自动计算', '原料价格波动预警'],
      },
      {
        icon: <AlertOutlined />,
        title: '临期商品主动预警',
        desc: '临近保质期商品自动预警，主动促销或调拨，降低过期损失。',
        points: ['临期商品多档预警', '主动促销建议', '过期损失自动统计'],
      },
    ],
  },
  beauty: {
    title: '个护化妆行业面临的经营管理痛点',
    painPoints: [
      { title: '规格全', desc: '色号、容量、套装和赠品关系复杂，资料维护易错' },
      { title: '核算赠品', desc: '满赠、换购与试用装频繁，库存消耗和活动成本不清' },
      { title: '有效期', desc: '批次、保质期与退换货信息断开，影响品质管理' },
      { title: '会员维护', desc: '线上线下客户行为割裂，复购和单客价值难判断' },
    ],
    solutions: [
      {
        icon: <GiftOutlined />,
        title: '多规格赠品组合管理',
        desc: '灵活配置单品、套装与赠品组合，自动核算组合成本与售价。',
        points: ['多规格 SKU 体系', '套装与赠品灵活组合', '组合商品自动拆单'],
      },
      {
        icon: <LineChartOutlined />,
        title: '会员复购深度分析',
        desc: '会员消费、积分与偏好全维度分析，精准触达提升复购。',
        points: ['RFM 客户分群', '复购周期预测', '个性化营销推荐'],
      },
      {
        icon: <BranchesOutlined />,
        title: '分销返利自动核算',
        desc: '分销商、加盟店多层级返利政策灵活配置，系统自动核算与结算。',
        points: ['多级分销返利', '返利自动结算', '分销业绩看板'],
      },
      {
        icon: <PercentageOutlined />,
        title: '促销活动灵活配置',
        desc: '满减、满赠、限时折扣、优惠券等多种活动灵活组合，跨渠道同步执行。',
        points: ['多活动叠加规则', '活动效果实时分析', '跨渠道一键同步'],
      },
    ],
  },
  digital: {
    title: '数码3C行业面临的经营管理痛点',
    painPoints: [
      { title: '序列号', desc: '采购、调拨、销售和售后信息分散，单品去向不清' },
      { title: '波动快', desc: '采购价和渠道价变化快，订单真实毛利难以及时计算' },
      { title: '渠道管理', desc: '门店、经销商和电商库存混用，渠道边界难控制' },
      { title: '售后服务', desc: '退换、保修与原销售单脱节，责任与成本核对耗时' },
    ],
    solutions: [
      {
        icon: <AuditOutlined />,
        title: '序列号级精细管理',
        desc: '每件商品唯一序列号，从入库、销售到售后全程留痕。',
        points: ['一物一码全程追踪', '序列号级库存账', '扫码快速查询履历'],
      },
      {
        icon: <ToolOutlined />,
        title: '保内保外维修工单',
        desc: '保内、保外维修工单分流管理，配件领用与工时费自动核算。',
        points: ['保内保外自动判定', '配件与工时费核算', '维修进度可视化'],
      },
      {
        icon: <RetweetOutlined />,
        title: '以旧换新价格策略',
        desc: '旧机回收价、置换差价灵活配置，自动生成置换订单与差价。',
        points: ['机型回收价库', '置换差价自动计算', '旧机入库单独管理'],
      },
      {
        icon: <EnvironmentOutlined />,
        title: '渠道窜货实时监控',
        desc: '序列号绑定出货区域，跨区域扫码自动预警，保护价格体系。',
        points: ['出货区域绑定', '跨区域扫码预警', '窜货报表与分析'],
      },
    ],
  },
  home: {
    title: '家居建材行业面临的经营管理痛点',
    painPoints: [
      { title: '品类杂', desc: '品类较多、数量多，维护成本高，效率低' },
      { title: '周期长', desc: '从报价到分批送货、安装和结算，状态难持续跟踪' },
      { title: '统计难', desc: '无法实时统计最新数据，影响核算与决策' },
      { title: '预收尾款', desc: '订金、阶段款、尾款与退补差价无法快速对应订单' },
    ],
    solutions: [
      {
        icon: <ProjectOutlined />,
        title: '定制订单进度看板',
        desc: '从量尺、设计、生产到安装全节点看板，客户与服务团队实时可见。',
        points: ['订单节点自定义', '客户扫码查看进度', '延期任务主动预警'],
      },
      {
        icon: <ContainerOutlined />,
        title: '材料耗用与项目成本',
        desc: '按项目归集材料、人工与费用，项目完工即可一键核算真实利润。',
        points: ['材料按单领用', '项目成本实时归集', '项目利润自动结算'],
      },
      {
        icon: <ScheduleOutlined />,
        title: '安装与售后工单协同',
        desc: '安装、售后工单与门店、施工队高效协同，服务过程透明可追溯。',
        points: ['工单智能派发', '施工队绩效统计', '客户评价与服务闭环'],
      },
      {
        icon: <CalendarOutlined />,
        title: '项目分期收款管理',
        desc: '按合同节点设置分期收款计划，到期自动提醒，资金回笼有保障。',
        points: ['合同分期计划', '到期收款提醒', '回款率分析看板'],
      },
    ],
  },
  apparel: {
    title: '服装鞋帽行业面临的经营管理痛点',
    painPoints: [
      { title: 'SKU多', desc: 'SKU组合数量大，门店找货、配货和盘点耗时' },
      { title: '识别慢', desc: '季节窗口短，销售与库存反馈慢会错过调整时机' },
      { title: '调拨难', desc: '各门店库存和销量割裂，缺货与积压同时发生' },
      { title: '账实差', desc: '跨店退换、换码与折扣销售难准确关联原单' },
    ],
    solutions: [
      {
        icon: <SkinOutlined />,
        title: '颜色尺码多维库存',
        desc: '按颜色、尺码、款式多维度管理库存，配货与盘点效率倍增。',
        points: ['多维度 SKU 管理', '智能配货建议', '门店扫码盘点'],
      },
      {
        icon: <StockOutlined />,
        title: '季末库存主动预警',
        desc: '基于销售周期与库龄，滞销库存自动预警，主动促销或调拨。',
        points: ['库龄多档分析', '滞销商品主动预警', '促销建议与折扣模板'],
      },
      {
        icon: <ShoppingCartOutlined />,
        title: '全渠道订单统一',
        desc: '门店、电商、批发订单统一管理，库存与会员数据全渠道打通。',
        points: ['全渠道订单归集', '会员积分通存通兑', '跨店跨仓库存共享'],
      },
      {
        icon: <ThunderboltOutlined />,
        title: '上新与折扣灵活配置',
        desc: '上新批次、折扣活动灵活配置，按店铺、渠道、客户群体精准执行。',
        points: ['上新批次管理', '多维度折扣模板', '活动效果实时跟踪'],
      },
    ],
  },
};

// 服务体系 — 4 张大卡片(暗色背景 + 独立图片 + 蒙层 + 底部文字)
const serviceSystem = [
  {
    img: serviceImg01,
    title: '实施交付',
    desc: '专属实施顾问协助初始化科目、期初数据与业务流程，最快 3 天上线。',
  },
  {
    img: serviceImg02,
    title: '培训赋能',
    desc: '视频课程、直播培训与操作手册相结合，新员工也能快速上手。',
  },
  {
    img: serviceImg03,
    title: '专属客服',
    desc: '7×12 小时在线支持，问题 30 分钟内响应，重要节点主动回访。',
  },
  {
    img: serviceImg04,
    title: '数据安全',
    desc: '金融级加密传输、多重备份与恢复机制，操作日志全程可追溯。',
  },
];

// 覆盖全行业 — 6 张大卡片(参考设计稿:背景图 + 底部蒙层 + 标签/标题/描述)
const industryOverview = [
  {
    key: 'beverage',
    img: industryBeverage,
    tag: '批次 / 效期',
    title: '食品酒水',
    desc: '涵盖批发、零售与渠道分销，管理批次效期、促销与往来。',
  },
  {
    key: 'fashion',
    img: industryFashion,
    tag: '款色 / 尺码',
    title: '服装鞋包',
    desc: '按款、色、码掌握库存与销量，支持门店调拨和季节经营。',
  },
  {
    key: 'hardware',
    img: industryHardware,
    tag: '规格 / 项目',
    title: '五金建材',
    desc: '应对多规格、多单位、项目报价与分批交付等复杂场景。',
  },
  {
    key: 'digital',
    img: industryDigital,
    tag: '串号 / 售后',
    title: '手机数码',
    desc: '序列号贯穿采购、库存、销售与售后，单品去向清晰可查。',
  },
  {
    key: 'home',
    img: industryHome,
    tag: '多品 / 补货',
    title: '家居日用',
    desc: '管理多品类商品和高频进出库，优化采购补货与库存周转。',
  },
  {
    key: 'general',
    img: industryGeneral,
    tag: '灵活 / 可配置',
    title: '其他商贸企业',
    desc: '通过可配置流程、权限与报表，适配成长型企业多种业态。',
  },
];

// 客户案例 — 一家企业从痛点到方案到成效的完整实践(参考设计稿)
const customerCases = [
  {
    title: '华南某宠物用品商贸企业：线上线下一体化经营实践',
    summary:
      '主营宠物用品及饲料，覆盖电商零售、线下门店和批发分销三条业务线，日均订单约 100 单。',
    meta: {
      model: ['电商零售', '实体门店', '批发分销'],
      scope: ['商品', '订单', '仓库', '往来', '财务'],
    },
    sections: [
      {
        heading: '业务痛点',
        content:
          '从线下批发拓展到电商零售后，各渠道订单仍靠表格人工归集，平台、门店与仓库库存各记各的账，缺货与积压并存；收付款与订单对不上时，财务需逐单回查原始单据，月末结账常拖到次月第 2 周。',
      },
      {
        heading: '落地方案',
        content:
          '统一线上线下商品、客户和价格档案，电商平台、门店与批发订单集中进入统一平台；按订单属性自动分配履约仓库，销售、出库、收款与财务往来连续衔接，并按岗位配置数据与操作权限。',
      },
      {
        heading: '实践成效',
        content:
          '订单不再跨表格搬运，仓库按系统任务拣配发货，库存实时联动各渠道；上线后盘点差异率由 3% 降至 0.5% 以内，财务结账周期由 7 天缩短至 2 天，管理层可实时查看销售、库存与回款情况。',
      },
    ],
  },
];

// 新设计的特性网格(每个行业 6 张卡片 — 参考设计稿)
const industryFeatureMap = {
  ecom: [
    { icon: <MobileOutlined />, title: '多平台多店铺统一经营', desc: '统一商品、客户与价格资料，集中承接各渠道经营数据。' },
    { icon: <ProfileOutlined />, title: '订单自动化高效履约', desc: '按规则审单、拆合单、分配仓库与物流，缩短发货周期。' },
    { icon: <DatabaseOutlined />, title: '多仓库存实时协同', desc: '同步实物、占用、在途与可售库存，设置上下限预警。' },
    { icon: <AccountBookOutlined />, title: '商品SKU精细管理', desc: '统一编码、规格与条码，支撑组合品和多属性商品管理。' },
    { icon: <CrownOutlined />, title: '业财一体自动核算', desc: '平台账单、收付款与业务单据自动衔接财务核算。' },
    { icon: <LineChartOutlined />, title: '经营利润实时洞察', desc: '按渠道、店铺、商品和订单穿透分析收入、费用与毛利。' },
  ],
  retail: [
    { icon: <ClusterOutlined />, title: '总部与门店统一管理', desc: '统一商品、价格、客户和权限规则，门店执行有标准。' },
    { icon: <TagsOutlined />, title: '销售订单驱动履约', desc: '订单直接联动备货、出库、配送与签收，全程可追踪。' },
    { icon: <CrownOutlined />, title: '门店多仓库存共享', desc: '实时查询各门店和仓库可用库存，支持智能调拨补货。' },
    { icon: <FileDoneOutlined />, title: '零售批发一套商品档案', desc: '一套商品资料兼容零售、批发、多单位与组合销售。' },
    { icon: <SyncOutlined />, title: '收款往来自动核销', desc: '销售、收款、退换货与客户欠款关联，账款状态清楚。' },
    { icon: <LineChartOutlined />, title: '门店经营对比分析', desc: '按门店、导购、商品与时段查看销售、周转和利润表现。' },
  ],
  food: [
    { icon: <ExperimentOutlined />, title: '批次与效期全程管理', desc: '入库记录生产日期和效期，临期分级预警并优先出库。' },
    { icon: <TruckOutlined />, title: '多渠道价格与促销控制', desc: '按客户、渠道和数量配置价格，促销执行有据可查。' },
    { icon: <ScheduleOutlined />, title: '食品流向快速追溯', desc: '从采购批次到销售客户双向追踪，退货责任快速定位。' },
    { icon: <AlertOutlined />, title: '多单位与条码管理', desc: '支持箱、件、瓶等单位换算及一品多码扫码作业。' },
    { icon: <TagsOutlined />, title: '经销往来自动核销', desc: '销售、回款、费用和返利统一归集，客户账目更清晰。' },
    { icon: <ProfileOutlined />, title: '效期库存智能补货', desc: '结合动销、库存、在途和效期生成补货与促销建议。' },
  ],
  beauty: [
    { icon: <GiftOutlined />, title: '品牌商品精细建档', desc: '统一管理品牌、系列、规格、色号、条码与套装关系。' },
    { icon: <LineChartOutlined />, title: '营销活动规则化执行', desc: '促销、赠品、换购与会员价自动校验并准确扣减。' },
    { icon: <BranchesOutlined />, title: '批次效期品质管理', desc: '批次入库、效期预警、销售去向与退货完整关联。' },
    { icon: <PercentageOutlined />, title: '多渠道库存一盘货', desc: '门店、电商与仓库共享库存，降低缺货和重复备货。' },
    { icon: <ExperimentOutlined />, title: '活动成本自动归集', desc: '赠品、折扣、平台费用与回款同步进入财务核算。' },
    { icon: <DatabaseOutlined />, title: '会员复购经营分析', desc: '按品类、客群与渠道识别复购贡献和高价值商品。' },
  ],
  digital: [
    { icon: <AuditOutlined />, title: '序列号全生命周期追踪', desc: '串号贯穿采购、入库、调拨、销售、退换与保修。' },
    { icon: <ToolOutlined />, title: '渠道价格精细控制', desc: '按客户等级、渠道与促销周期管理价格和授权范围。' },
    { icon: <RetweetOutlined />, title: '单品库存精准可查', desc: '按仓库和串号查询状态，避免重复销售与渠道串货。' },
    { icon: <EnvironmentOutlined />, title: '配件组合一体管理', desc: '主机、配件、套装和赠品关联出库，成本同步归集。' },
    { icon: <DatabaseOutlined />, title: '售后业务关联原单', desc: '退换、维修和保修快速定位客户、串号与原销售记录。' },
    { icon: <FileDoneOutlined />, title: '实时单品毛利分析', desc: '结合批次成本、费用和售价，查看渠道与机型真实利润。' },
  ],
  home: [
    { icon: <ProjectOutlined />, title: '多规格多单位管理', desc: '统一尺寸、材质、颜色与换算规则，报价下单更准确。' },
    { icon: <ContainerOutlined />, title: '项目订单全程跟踪', desc: '报价、合同、备货、分批交付与安装节点连续可查。' },
    { icon: <ScheduleOutlined />, title: '项目库存预留协同', desc: '区分实物、项目占用、在途与可用库存，保障交付。' },
    { icon: <CalendarOutlined />, title: '客户专属价格体系', desc: '按客户、项目和数量配置报价策略，保留完整价格依据。' },
    { icon: <TagsOutlined />, title: '预收应收自动核销', desc: '订金、阶段款和尾款对应项目订单，往来清晰。' },
    { icon: <ProfileOutlined />, title: '项目收入成本分析', desc: '按项目归集商品成本、费用与回款，掌握交付利润。' },
  ],
  apparel: [
    { icon: <AppstoreOutlined />, title: '款色尺码矩阵管理', desc: '按款号快速维护颜色尺码，矩阵查询库存与销量。' },
    { icon: <SyncOutlined />, title: '门店配货智能协同', desc: '结合门店动销和可用库存，支持配货、补货与调拨。' },
    { icon: <HomeOutlined />, title: '全渠道库存共享', desc: '门店、电商与仓库共享可售库存，提升现货满足率。' },
    { icon: <CalendarOutlined />, title: '季节商品经营管理', desc: '按波段、季节和系列跟踪上市、动销与清货节奏。' },
    { icon: <SwapOutlined />, title: '退换货关联原销', desc: '换色换码、跨店退货与退款同步更新库存和往来。' },
    { icon: <LineChartOutlined />, title: '商品结构与毛利分析', desc: '按款、色、码、门店识别畅销和真实利润贡献。' },
  ],
};

const Solutions = () => {
  const [activeTab, setActiveTab] = useState('ecom');
  const currentIndustry = industryContentMap[activeTab];
  // 标题前缀取自当前 Tab 标签(如 "电商通用"),后缀是 title 的剩余部分 — 前缀单独着色
  const activeTabInfo = industryTabs.find((t) => t.key === activeTab);
  const titlePrefix = activeTabInfo?.label || '';
  const titleSuffix = currentIndustry.title.slice(titlePrefix.length);

  return (
    <div className="page-solutions">
      {/* Hero */}
      <section className="solutions-hero">
        <div className="solutions-hero-content">
          <Title level={1} className="solutions-hero-title">
            解决方案
          </Title>
        </div>
      </section>

      {/* 行业 Tab 导航 */}
      <nav className="solutions-tabs">
        <div className="solutions-tabs-inner">
          {industryTabs.map((tab) => (
            <div
              key={tab.key}
              className={`solutions-tab ${
                activeTab === tab.key ? 'solutions-tab--active' : ''
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </nav>

      {/* 痛点 — 当前选中行业 */}
      <section className="solutions-section">
        <div className="solutions-section-inner">
          <ScrollReveal>
            <div className="solutions-section-head">
              <Title level={2} className="solutions-section-title">
                <span className="solutions-section-title-prefix">{titlePrefix}</span>
                {titleSuffix}
              </Title>
              <span className="solutions-section-underline" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <Paragraph
              style={{
                textAlign: 'center',
                fontSize: '1.0625rem',
                color: '#5a6878',
                maxWidth: '46rem',
                margin: '0 auto 2.5rem',
                lineHeight: 1.8,
              }}
            >
              {currentIndustry.desc}
            </Paragraph>

            <Row gutter={[20, 20]}>
              {currentIndustry.painPoints.map((p) => (
                <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 6 }} key={p.title}>
                  <div className="pain-point-card">
                    <div className="pain-point-card-header">
                      <h3 className="pain-point-card-title">{p.title}</h3>
                    </div>
                    <div className="pain-point-card-body">
                      <p className="pain-point-card-desc">{p.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </ScrollReveal>
        </div>
      </section>

      {/* ===== 解决方案:Tab + 6 卡片特性网格(参考设计稿) ===== */}
      <section className="solutions-feature-grid-section">
        <div className="solutions-feature-grid-inner">
          <ScrollReveal>
            <div className="solutions-feature-grid-head">
              <Title level={2} className="solutions-feature-grid-title">
                解决方案
              </Title>
              <span className="solutions-feature-grid-underline" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={120}>
            <Row gutter={[24, 24]}>
              {industryFeatureMap[activeTab].map((f) => (
                <Col xs={24} md={12} key={f.title}>
                  <div className="solution-grid-card">
                    <div className="solution-grid-card-icon">{f.icon}</div>
                    <div className="solution-grid-card-content">
                      <h3 className="solution-grid-card-title">{f.title}</h3>
                      <p className="solution-grid-card-desc">{f.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </ScrollReveal>
        </div>
      </section>

      {/* 覆盖全行业 — 6 张背景图卡片(参考设计稿) */}
      <section className="solutions-industry-overview">
        <div className="solutions-industry-overview-inner">
          <ScrollReveal>
            <div className="solutions-section-head">
              <Title level={2} className="solutions-section-title">
                覆盖全行业
              </Title>
              <span className="solutions-section-underline" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={120}>
            <Row gutter={[20, 20]}>
              {industryOverview.map((item) => (
                <Col xs={24} sm={12} md={8} key={item.key}>
                  <div
                    className="industry-overview-card"
                    style={{ '--bg-image': `url(${item.img})` }}
                  >
                    <div className="industry-overview-card-content">
                      <span className="industry-overview-card-tag">{item.tag}</span>
                      <h3 className="industry-overview-card-title">{item.title}</h3>
                      <p className="industry-overview-card-desc">{item.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </ScrollReveal>
        </div>
      </section>

      {/* 客户案例 — 完整实践(参考设计稿) */}
      <section className="solutions-section">
        <div className="solutions-section-inner">
          <ScrollReveal>
            <div className="solutions-section-head">
              <Title level={2} className="solutions-section-title">
                客户案例
              </Title>
              <span className="solutions-section-underline" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={120}>
            {customerCases.map((c) => (
              <div className="customer-case-card" key={c.title}>
                <h3 className="customer-case-card-title">{c.title}</h3>
                <p className="customer-case-card-summary">{c.summary}</p>

                <div className="customer-case-card-meta">
                  <div className="customer-case-card-meta-item">
                    <span className="customer-case-card-meta-label">经营模式</span>
                    <span className="customer-case-card-meta-value">
                      {c.meta.model.join(' · ')}
                    </span>
                  </div>
                  <div className="customer-case-card-meta-item">
                    <span className="customer-case-card-meta-label">管理范围</span>
                    <span className="customer-case-card-meta-value">
                      {c.meta.scope.join(' · ')}
                    </span>
                  </div>
                </div>

                <div className="customer-case-card-body">
                  {c.sections.map((s) => (
                    <div className="customer-case-card-section" key={s.heading}>
                      <h4 className="customer-case-card-section-heading">
                        {s.heading}
                      </h4>
                      <p className="customer-case-card-section-content">
                        {s.content}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </ScrollReveal>
        </div>
      </section>

      {/* 服务体系 — 4 张独立图片卡片(暗色背景 + 服务图片) */}
      <section className="solutions-service-system">
        <div className="solutions-service-system-inner">
          <ScrollReveal>
            <div className="solutions-service-system-head">
              <Title level={2} className="solutions-service-system-title">
                服务体系
              </Title>
              <span className="solutions-service-system-underline" />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={120}>
            <Row gutter={[16, 16]}>
              {serviceSystem.map((item) => (
                <Col xs={24} sm={12} md={6} key={item.title}>
                  <div
                    className="service-system-card"
                    style={{
                      '--service-card-bg': `url(${item.img})`,
                    }}
                  >
                    <div className="service-system-card-mask" />
                    <div className="service-system-card-content">
                      <h3 className="service-system-card-title">{item.title}</h3>
                      <p className="service-system-card-desc">{item.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
